// Product Card Swiper - Smart Initialization
(function() {
    'use strict';
    
    function initProductCardSwipers() {
        if (typeof Swiper === 'undefined') {
            setTimeout(initProductCardSwipers, 100);
            return;
        }
        
        const swiperElements = document.querySelectorAll('.product-card-swiper:not([data-swiper-init])');
        const isMobileOrTablet = window.innerWidth <= 1024;
        
        swiperElements.forEach((element) => {
            // Check if this swiper is in the ls-feat-products section
            const isInProductList = element.closest('[data-section-id*="ls-feat-products"]') || 
                                   element.closest('#shopify-section-template--23281633321302__ls-feat-products');
            
            // Skip initialization for ls-feat-products on mobile/tablet
            if (isMobileOrTablet && isInProductList) {
                element.setAttribute('data-swiper-init', 'skip');
                return;
            }
            
            element.setAttribute('data-swiper-init', 'true');
            
            const slides = element.querySelectorAll('.swiper-slide');
            if (slides.length <= 1) return;
            
            const nextButton = element.querySelector('.swiper-button-next');
            const prevButton = element.querySelector('.swiper-button-prev');
            
            try {
                new Swiper(element, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: false,
                    speed: 300,
                    navigation: {
                        nextEl: nextButton,
                        prevEl: prevButton,
                    },
                    allowTouchMove: !isMobileOrTablet, // Allow touch on mobile for featured collection
                });
            } catch (error) {
                console.error('Error initializing swiper:', error);
                element.removeAttribute('data-swiper-init');
            }
        });
    }
    
    document.addEventListener('DOMContentLoaded', initProductCardSwipers);
    window.addEventListener('load', initProductCardSwipers);
    
    document.addEventListener('shopify:section:load', initProductCardSwipers);
    document.addEventListener('shopify:section:reload', initProductCardSwipers);
    
    // Reinitialize on resize (e.g., when rotating device)
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            // Remove all init markers and reinitialize
            document.querySelectorAll('.product-card-swiper[data-swiper-init]').forEach(el => {
                el.removeAttribute('data-swiper-init');
            });
            initProductCardSwipers();
        }, 250);
    });
})();
